const state = {
  units: [],
  showDialog: false,
};

const mutations = {
  setUnits(state, payload) {
    state.units = payload;
  },
  setShowDialog(state, payload) {
    state.showDialog = payload;
  },
  resetDialog(state) {
    state.showDialog = false;
    state.units = [];
  },
};

const actions = {
  setUnitsState({ commit }, payload) {
    commit('setUnits', payload);
  },
  setShowDialogState({ commit }, payload) {
    commit('setShowDialog', payload);
  },
  resetDialogState({ commit }) {
    commit('resetDialog');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
